import type {
  DroneMaintenancePartId,
  IDroneMaintenancePart,
  IGetDroneMaintenanceResponse,
} from '@src/features/fleet/redux/types';
import type { RuntimeItem } from '../types';

export const SECONDS_PER_HOUR = 3600;

const MOTOR_KEYS = ['motor1', 'motor2', 'motor3', 'motor4', 'motor5', 'motor6'] as const;
const PROP_KEYS = ['prop1', 'prop2', 'prop3', 'prop4', 'prop5', 'prop6'] as const;

function partToRuntimeItem({
  name,
  part,
  partId,
  type,
}: {
  name: string;
  part: IDroneMaintenancePart;
  partId: DroneMaintenancePartId;
  type: RuntimeItem['type'];
}): RuntimeItem {
  const totalHours = Math.round(part.totalHour / SECONDS_PER_HOUR);
  const limitHours = Math.round(part.limitHour / SECONDS_PER_HOUR);
  const progressValue = limitHours > 0 ? Math.min(100, Math.round((totalHours / limitHours) * 100)) : 0;
  const hoursLabel = `${totalHours}h / ${limitHours}h`;

  return {
    partId,
    name,
    currentHours: totalHours,
    limitHours,
    hoursLabel,
    progressValue,
    type,
  };
}

export function getMotorRuntimeItems(
  maintenance: IGetDroneMaintenanceResponse | undefined
): RuntimeItem[] {
  if (!maintenance) return [];

  return MOTOR_KEYS.map((key, index) =>
    partToRuntimeItem({
      name: `Motor ${index + 1}`,
      part: maintenance[key],
      partId: `MOTOR${index + 1}` as DroneMaintenancePartId,
      type: 'motor',
    })
  );
}

export function getPropellerRuntimeItems(
  maintenance: IGetDroneMaintenanceResponse | undefined
): RuntimeItem[] {
  if (!maintenance) return [];

  return PROP_KEYS.map((key, index) =>
    partToRuntimeItem({
      name: `Propeller ${index + 1}`,
      part: maintenance[key],
      partId: `PROP${index + 1}` as DroneMaintenancePartId,
      type: 'propeller',
    })
  );
}
